/**
 * Кодек: сериализация и разбор в одном месте.
 *
 * Сейчас это JSON поверх Socket.IO - ровно то, что делает конкурент. Смысл
 * отдельного модуля не в текущей реализации, а в том, что она ОДНА: когда в
 * Фазе 4 появится квантование координат и дельты, менять придётся этот файл,
 * а не два десятка мест, где кто-то написал JSON.stringify руками.
 *
 * Место под квантование заложено ниже и уже описано числами из замеров - без
 * него `blob-battle` передаёт 2 239 байт координат на пакет с точностью до 16
 * значащих цифр там, где хватает одного знака после запятой
 * (docs/ARCHITECTURE.md, 3.2, правило 2).
 */
/**
 * Квант координаты по умолчанию: 0,1 логического пикселя.
 *
 * Кадр overlay - 1080 x 1920 логических пикселей (docs/ARCHITECTURE.md, 5.1).
 * Десятая доля пикселя лежит далеко за порогом различимости на любом экране,
 * а в JSON экономит от четырёх до тринадцати символов на каждое число.
 */
export const COORDINATE_QUANTUM = 0.1;
/**
 * Квантование одной координаты. Применяется схемой игры, не разработчиком.
 *
 * ДЕЛЕНИЕМ НА ОБРАТНУЮ ВЕЛИЧИНУ, А НЕ УМНОЖЕНИЕМ НА КВАНТ. Разница выглядит
 * придиркой и таковой не является: `Math.round(x / 0.1) * 0.1` даёт ближайшее
 * двоичное число НЕ к 530,2, а на единицу младшего разряда в сторону, и в JSON
 * оно печатается как `530.2000000000001` - двадцать байт вместо пяти.
 *
 * Замер на случайных координатах кадра: умножением худшее число занимает 20
 * байт, делением - 7. То есть квантование, написанное очевидным образом,
 * СТОИТ дороже, чем его отсутствие, и при этом выглядит работающим: значения
 * правильные, тесты на точность зелёные, а по каналу едет ровно та «полная
 * двойная точность до шестнадцати значащих цифр», из-за которой у конкурента
 * координаты занимают 2 239 байт на пакет.
 *
 * Найдено воротами трафика класса `entities`: две тысячи сущностей не
 * укладывались в бюджет, и весь перерасход оказался цифрами после запятой.
 */
export function quantize(value, quantum = COORDINATE_QUANTUM) {
    const scale = 1 / quantum;
    return Math.round(value * scale) / scale;
}
/**
 * Сериализация исходящего сообщения.
 *
 * Socket.IO сам сериализует объекты, поэтому функция возвращает payload как
 * есть. Она существует как единственная точка, в которой это решение можно
 * будет поменять - например, на бинарный формат для канала состояния.
 */
export function encode(payload) {
    return payload;
}
/**
 * Разбор входящего сообщения.
 *
 * Проверка - структурная, а не доверительная: сообщение приходит из сети, и
 * `as T` без проверки означал бы падение рендера на кривом пакете. Пока
 * проверяется только то, что это объект; схемные проверки появятся вместе с
 * каналом состояния, где формат сложный.
 */
export function decode(raw) {
    if (raw === null || typeof raw !== 'object') {
        return null;
    }
    return raw;
}
//# sourceMappingURL=codec.js.map